/**
 * Throttles calls to a function to ensure they only happen on a request animation frame.
 */
export default function rafThrottle<T extends (...args: any[]) => void>(fn: T) {
    let requestId: number | null;
    let latestArgs: Parameters<T>;

    const throttled = (...args: Parameters<T>) => {
        latestArgs = args;

        // If we have already requested an animation frame, return
        if (requestId) return;

        // Wait an animation frame
        requestId = requestAnimationFrame(() => {
            requestId = null;
            fn(...latestArgs);
        });
    };

    throttled.cancel = () => {
        if (!requestId) return;
        cancelAnimationFrame(requestId);
        requestId = null;
    };

    return throttled;
}
